import * as actionTypes from '../types/processing';

export function getProcessingStart(payload) {
  return {
    type: actionTypes.GET_PROCESSING_START,
    payload
  };
}
export function getProcessingStartSuccess(payload) {
  return {
    type: actionTypes.GET_PROCESSING_START_SUCCESS,
    payload
  };
}
export function getProcessingStartFail(payload) {
  return {
    type: actionTypes.GET_PROCESSING_START_FAIL,
    payload
  };
}

export function getProcessingStartCancel(payload) {
  return {
    type: actionTypes.GET_PROCESSING_START_CANCEL,
    payload
  };
}
export function getProcessingStartCancelSuccess(payload) {
  return {
    type: actionTypes.GET_PROCESSING_START_CANCEL_SUCCESS,
    payload
  };
}
export function getProcessingStartCancelFail(payload) {
  return {
    type: actionTypes.GET_PROCESSING_START_CANCEL_FAIL,
    payload
  };
}

export function getProcessingStartClear(payload) {
  return {
    type: actionTypes.GET_PROCESSING_START_CLEAR,
    payload
  };
}
export function getAwaitingProcessingStart(payload) {
  return {
    type: actionTypes.GET_AWAITING_PROCESSING_START,
    payload
  };
}
export function getAwaitingProcessingStartSuccess(payload) {
  return {
    type: actionTypes.GET_AWAITING_PROCESSING_START_SUCCESS,
    payload
  };
}
export function getAwaitingProcessingStartFail(payload) {
  return {
    type: actionTypes.GET_AWAITING_PROCESSING_START_FAIL,
    payload
  };
}
